.overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
}

.modalContent {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--static-background-standard);
  border-radius: 12px;
  z-index: 999;
  max-height: 94vh;
}

.modalHeader {
  background: var(--static-background-standard);
  padding: 1.25rem;
  border-radius: 12px;
}

.modalBody {
  padding: 1rem 1.5rem;
  background: var(--static-background-standard);
  border-radius: 12px;
  overflow: auto;
  display: flex;
  flex-direction: column;
}

.modalFooter {
  background: var(--static-background-standard);
  padding: 1rem 1.5rem;
  border-radius: 12px;
}

.closeButton {
  position: absolute;
  display: grid;
  place-items: center;
  top: 0.5rem;
  right: 0.5rem;
  cursor: pointer;
  background-color: transparent;
  border: none;
  border-radius: 12px;
  padding: 0.5rem;
  z-index: 2;
  color: var(--static-text-standard);
}

.closeButton:hover {
  color: var(--primary-enabled);
}

@keyframes overlayShow {
  0% {
    opacity: 0
  }

  100% {
    opacity: 1
  }
}

@keyframes contentHide {
  100% {
    opacity: 0;
    transform: translate(-50%, -48%) scale(.96);
  }

  0% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes contentShow {
  0% {
    opacity: 0;
    transform: translate(-50%, -48%) scale(.96);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@media (prefers-reduced-motion: no-preference) {
  .overlay[data-state="open"] {
    animation: overlayShow 500ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .overlay[data-state="closed"] {
    animation: overlayShow 500ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .modalContent[data-state="open"] {
    animation: contentShow 100ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }

  .modalContent[data-state="closed"] {
    animation: contentHide 200ms cubic-bezier(0.16, 1, 0.3, 1) forwards;
  }
}